import { AreaResource, AreaType } from '../../area.resource';

export class AreaEurekamLiteResource extends AreaResource {
  public static readonly TYPE =  AreaType.eurekam_lite;

  id:any;
  links:any;

  commesse: any[] = [];
  request_type: any;
  membership_group: any;
  group_name: string;
  description_group: string;
  notes: string = '';

  constructor() {
    super(AreaEurekamLiteResource.TYPE);
  }
}


export class OrderResource {
  segment_code: string;
  project_name: string;
  project_description: string;
  active: boolean;
  cdc_type: string;
}

export class RequestTypeOrMembershipGroupResource {
  id: number;
  value: string;
  description: string;
}